<template>
    <div id="opp_form_modal">
        <form @submit.prevent="submitForm">
            <p>Submit</p>
            
            <label>
                Company Name
                <input type="text" name="company_name" v-model="company_name">
            </label>

            <label>
                Company Type
                <select v-model="company_type">
                    <option disabled="" selected="" value="">Select Option</option>
                    <option v-for="(option, index) in companyTypes" :key="index" :value="option">{{option}}</option>
                </select>
            </label>

            <label>
                Line(s) of Business
                <select v-model="lines_of_business">
                    <option disabled="" selected="" value="">Select Option</option>
                    <option v-for="(option, index) in businessLines" :key="index" :value="option">{{option}}</option>
                </select>
            </label>

            <label>
                Client Type
                <select v-model="client_type">
                    <option disabled="" selected="" value="">Select Option</option>
                    <option v-for="(option, index) in clientTypes" :key="index" :value="option">{{option}}</option>
                </select>
            </label>

            <label>
                Contract Type
                <select v-model="contract_type">
                    <option disabled="" selected="" value="">Select Option</option>
                    <option v-for="(option, index) in contractTypes" :key="index" :value="option">{{option}}</option>
                </select>
            </label>

            <label>
                Contact Name
                <input type="text" name="contact_name" v-model="contact_name">
            </label>

            <label>
                Contact Number
                <input type="tel" name="contact_number" v-model="contact_number">
            </label>

            <label>
                Email Address
                <input type="email" name="email_address" v-model="email_address">
            </label>

            <label v-if="user.user_role == 'Manager'">
                Opportunity Owner
                <select v-model="opportunity_owner">
                    <option v-for="(user, index) in getCompanyUsers" :key="index" :value="user._id">{{user.name}}</option>
                </select>
            </label>


            <label v-bind:class="{'mr-0' : manager}">
                Division
                <select v-model="division">
                    <option disabled="" selected="" value="">Select Option</option>
                    <option v-for="(div, index) in divisions" :key="index" :value="div">{{div}}</option>
                </select>
            </label>

            <label v-bind:class="{'offset' : manager}">
                Decision Maker Name
                <input type="text" name="decision_maker" v-model="decision_maker">
            </label>

            <label>
                Annual Jobs
                <input 
                    type="number" 
                    name="annual_jobs"
                    step="1"
                    min="1"
                    v-model.number="annual_jobs" 
                    v-on:input="calculateAnnualValue"
                >
            </label>

            <label>
                Average Fee
                <input 
                    type="text" 
                    name="average_fee" 
                    v-model.number="average_fee" 
                    v-on:input="calculateAnnualValue"
                    >
            </label>

            <label>
                Annual Value
                <input 
                    type="text"
                    name="annual_value"
                    v-model="annual_value"
                >
            </label>

            <label v-bind:class="{'mr-0' : manager}">
                Next Steps
                <input type="text" name="next_steps" v-model="next_steps">
            </label>

            <label v-bind:class="{'widthNormal' : manager}">
                Due Date
                <input type="date" v-model="due_date">
            </label>

            <label v-bind:class="{'widthNormal' : manager}">
                Close By Date
                <input type="date" v-model="close_by_date">
            </label>

            <label v-bind:class="{'widthFull' : manager}">
                Notes
                <textarea v-model="notes"></textarea>
            </label>

            <button v-on:click="toggleForm">Close</button>
            
            <button type="submit">Submit</button>

            <div v-if="validation.error" class="form-error">
                <p v-for="(msg, index) in validation.msg" :key="index">{{ msg }}</p>
                <button v-on:click="validation.error = false">Ok</button>
            </div>
        </form>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import axios from 'axios';

    export default {
        name: 'oppForm',
        data() {
            return {
                company_name: '',
                company_type: '',
                lines_of_business: '',
                client_type: '',
                contract_type: '',
                contact_name: '',
                contact_number: '',
                email_address: '',
                opportunity_owner: '',
                decision_maker: '',
                annual_jobs: '',
                average_fee: '',
                annual_value: '',
                next_steps: '',
                due_date: '',
                close_by_date: '',
                division: '',
                notes: '',
                validation: {
                    error: false,
                    msg: []
                }
            }
        },
        computed: {
            ...mapGetters([
                'divisions',
                'businessLines',
                'clientTypes',
                'contractTypes',
                'companyTypes',
                'user',
                'getCompanyUsers'
            ]),
            manager() {
                if (this.user.user_role == 'Manager') {
                    return true;
                }
                return false;
            },
            selectedColumn() {
                return this.$store.state.Dashboard.selectedColumn;
            }
        },
        created() {
            // this.getBusinessLines();
            // this.getClientTypes();
            // this.getContractTypes();
            // this.getCompanyTypes();

            if (this.user.user_role == 'Manager') {
                this.opportunity_owner = this.user._id;
            }
        },
        methods: {
            ...mapActions([
                'getAllBoardPostData',
                'toggleSubmitFormVisibility',
                // 'add_iso_to_array'
                // 'getBusinessLines',
                // 'getClientTypes',
                // 'getContractTypes',
                // 'getCompanyTypes'
            ]),
            toggleForm() {
                this.toggleSubmitFormVisibility();
            },
            submitForm() {
                if (this.validate_form()) {
                    // if column index is set else send to first
                    let columnIndex = (this.selectedColumn !== '' ) ? this.selectedColumn : 0;
                    let authorId;
                    let authorName;

                    // console.log(this.selectedColumn);
                    // console.log(columnIndex);

                    // if author is set get author name and id 
                    if (this.opportunity_owner !== '') {
                        let isoAuthor = this.getCompanyUsers.filter((user) => {
                            return user._id === this.opportunity_owner;
                        });

                        authorId = isoAuthor[0]._id;
                        authorName = isoAuthor[0].name;
                    } else {
                        authorId = '';
                        authorName = '';
                    }

                    let post = {
                        company_name: this.company_name,
                        company_type: this.company_type,
                        lines_of_business: this.lines_of_business,
                        client_type: this.client_type,
                        contract_type: this.contract_type,
                        contact_name: this.contact_name,
                        contact_number: this.contact_number,
                        email_address: this.email_address,
                        author_id: authorId,
                        author_name: authorName,
                        decision_maker: this.decision_maker,
                        annual_jobs: this.annual_jobs,
                        average_fee: parseInt(this.average_fee.replace(/[^0-9]/g, '')),
                        annual_value: parseInt(this.annual_value.replace(/[^0-9]/g, '')),
                        next_steps: this.next_steps,
                        due_date: this.due_date,
                        close_by_date: this.close_by_date,
                        division: this.division,
                        column: columnIndex,
                        notes: this.notes
                    };

                    axios.post('api/summary-board/new-opportunity', post)
                        .then(() => {
                            this.getAllBoardPostData();

                            // this.add_iso_to_array(post);
                            this.toggleForm();
                        })
                        .catch(function(error) {
                            console.log(error);
                        });
                } 
                // /*
                // if column index has been set in the store buy clicking one of the addition buttons at the top of each stage
                // we set the column index for the iso else it goes to the first column
                // */
                // if (this.selectedColumn !== '') {
                //     // if the iso is not being post to the first column
                //     if (this.selectedColumn > 0) {
                //         // if iso doesn't have a due date display error
                //         if (this.due_date === '') {
                //             this.validation.error = true;
                //         } else {
                //             // date is set and we want to post into a specfic column so we pass the col index to the post funciton
                //             this.post_iso(this.selectedColumn);
                //         }
                //     } else {
                //         // the iso is being post into the first column so we just call the post function
                //         this.post_iso();
                //     }
                // } else {
                //     this.post_iso();
                // }
            },
            post_iso(index) {
                // if column index is set else send to first
                let columnIndex = (index !== undefined ) ? index : 0;
                let authorId;
                let authorName;

                // if author is set get author name and id 
                if (this.opportunity_owner !== '') {
                    let isoAuthor = this.getCompanyUsers.filter((user) => {
                        return user._id === this.opportunity_owner;
                    });

                    authorId = isoAuthor[0]._id;
                    authorName = isoAuthor[0].name;
                } else {
                    authorId = '';
                    authorName = '';
                }

                let post = {
                    company_name: this.company_name,
                    company_type: this.company_type,
                    lines_of_business: this.lines_of_business,
                    client_type: this.client_type,
                    contract_type: this.contract_type,
                    contact_name: this.contact_name,
                    contact_number: this.contact_number,
                    email_address: this.email_address,
                    author_id: authorId,
                    author_name: authorName,
                    decision_maker: this.decision_maker,
                    annual_jobs: this.annual_jobs,
                    average_fee: parseInt(this.average_fee.replace(/[^0-9]/g, '')),
                    annual_value: parseInt(this.annual_value.replace(/[^0-9]/g, '')),
                    next_steps: this.next_steps,
                    due_date: this.due_date,
                    close_by_date: this.close_by_date,
                    division: this.division,
                    column: columnIndex,
                    notes: this.notes
                };

                axios.post('api/summary-board/new-opportunity', post)
                    .then(() => {
                        this.getAllBoardPostData();

                        // this.add_iso_to_array(post);
                        this.toggleForm();
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            },
            calculateAnnualValue() {
                let anJobs = Math.trunc(this.annual_jobs);
                let avFee = this.average_fee.toString().replace(/[^0-9]/g, '');

                if (anJobs !== '' && anJobs > 0 && avFee !== '') {
                    this.annual_jobs = anJobs;
                    this.average_fee = '£' + parseInt(avFee).toLocaleString('en-GB');
                    this.annual_value = '£' + parseInt(anJobs * avFee).toLocaleString('en-GB');
                } else {
                    this.annual_value = '';
                }
            },
            validate_form() {
                this.validation.msg = [];

                if (this.selectedColumn !== '') {
                    // if the iso is not being post to the first column
                    if (this.selectedColumn > 0) {
                        // if iso doesn't have a due date display error
                        if (this.due_date === '') {
                            this.validation.error = true;
                            this.validation.msg.push('Due Date is required to post directly into this stage of the pipeline.');
                        }
                    }
                }

                if (this.division === '') {
                    this.validation.error = true;
                    this.validation.msg.push('Divison is Required.');
                }

                // if we have errors
                if (this.validation.msg.length > 0) {
                    return false;
                }else {
                    return true;
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    #opp_form_modal{
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        background-color: #fff;
        border: 0.3rem solid #6693bc;

        .close_button{
            position: absolute;
            top: 1rem;
            right: 1rem;

            line{
                stroke: #1f2527;
                stroke-width: .3rem;
                stroke-linecap: round;
            }
        }

        form{
            display: flex;
            flex-wrap: wrap;
            width: 80rem;
            padding: 5rem 3.5rem;

            p{
                text-align: center;
                width: 100%;
                font-size: 4rem;
                line-height: 1.3;
                font-weight: 600;
                color: #6693bc;
                margin-bottom: 5rem;
            }

            label{
                width: 33.33333%;
                font-size: 1.8rem;
                line-height: 1.3;
                font-weight: 600;
                padding: 0 1.5rem;
                margin-bottom: 1.5rem;
                color: #6693bc;

                &:nth-of-type(10){
                    margin-right: 66.66666%;
                    margin-bottom: 3rem;   
                }

                // &:nth-of-type(15){
                //     margin-right: 33.33333%;

                // }

                &:nth-of-type(17){
                    width: 100%;
                }

                &.mr-0 {
                    margin-right: 0;
                }

                &.offset {
                    margin-right: 33.33333%;
                }
                
                &.widthNormal {
                    width: 33.33333%;
                }

                &.widthFull {
                    width: 100%;
                }

                input{
                    display: block;
                    width: 100%;
                    margin-top: 0.5rem;
                    border: 0.1rem solid #355364;
                    font-size: 1.6rem;
                    line-height: 1.3;
                    font-weight: 500;
                    color: #355364;
                    padding: 0.25rem 0.5rem;
                }

                textarea{
                    display: block;
                    width: 100%;
                    margin-top: 0.5rem;
                    border: 0.1rem solid #355364;
                    font: unset;
                    font-size: 1.6rem;
                    line-height: 1.3;
                    font-weight: 500;
                    color: #355364;
                    height: 6em;
                    padding: 0.25rem 0.5rem;
                }

                /* Firefox remove arrows*/
                input[type=number] {
                   -moz-appearance: textfield;
                }
                /* Chrome, Safari, Edge, Opera - remove arrows*/
                input::-webkit-outer-spin-button, input::-webkit-inner-spin-button {
                    -webkit-appearance: none;
                    margin: 0;
                }

                // textarea{
                //     display: block;
                //     width: 100%;
                //     margin-top: 0.5rem;
                // }

                select{
                    display: block;
                    width: 100%;
                    margin-top: 0.5rem;
                    border: 0.1rem solid #355364;
                    font-size: 1.6rem;
                    line-height: 1.3;
                    font-weight: 500;
                    color: #355364;
                    padding: 0.25rem 0.5rem;
                }
            }

            button{
                margin: 0 auto;
                font-size: 2rem;
                line-height: 1.3;
                font-weight: 600;
                color: #fff;
                background-color: #6693bc;
                border: 0;
                padding: 1rem 3rem;
                margin-top: 1.5rem;
            }

            .form-error {
                display: flex;
                flex-wrap: wrap;
                position: fixed;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                background-color: #fff;
                border: 0.3rem solid #6693bc;
                padding: 3rem;

                p {
                    font-size: 1.8rem;
                    margin: 0 0 2rem 0;
                    width: 100%;
                }

                button {
                    margin: 0 auto;
                }
            }
        }
    }
</style>